import * as _ from 'lodash';
import type { ReactElement, VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { window } from '../../globals';
import { useDispatchOnMount } from '../../hooks';
import OrganizationModule from '../../redux/organizations';
import { hasError } from '../../utils';
import { ErrorAlert } from '../generic';
import Loader from '../generic/Loader';

const OrgInfoCard: VoidFunctionComponent = () => {
  const keysToShow = ['id', 'title', 'access_level', 'stripe_plan', 'security_enabled', 'quality_policy_enabled', 'isInternal', 'updatedAt', 'createdAt'];
  const orgDomains = useSelector(OrganizationModule.selectors.getOrgDomains);

  useDispatchOnMount(OrganizationModule.actions.fetchOrganizationDomains, window.user?.organizationId);

  let ssoDomainsBody: ReactElement;
  if (hasError(orgDomains.status)) {
    ssoDomainsBody = <ErrorAlert status={orgDomains.status} withMargin />;
  } else if (orgDomains.status.loading) {
    ssoDomainsBody = <Loader />;
  } else if (orgDomains.domains.length === 0) {
    ssoDomainsBody = (
      <p className="margin-left-md margin-bottom-md">None</p>
    );
  } else {
    ssoDomainsBody = (
      <div className="flex-table">
        <div className="flex-table--header">
          <div className="flex-table--header--cell"><b>Domain</b></div>
          <div className="flex-table--header--cell"><b>SSO Method</b></div>
        </div>
        {orgDomains.domains.map(({ domain, ssoMethod }) => (
          <div key={domain} className="flex-table--row">
            <div className="flex-table--row--cell">{domain}</div>
            <div className="flex-table--row--cell">{ssoMethod}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="panel">
      <h2 className="text-center">Organization Info</h2>
      <div className="flex-table">
        {/* eslint-disable-next-line you-dont-need-lodash-underscore/map */}
        {window.user?.organization && _.map(_.pick((window.user.organization), keysToShow), (val: string, key) => (
          <div key={key} className="flex-table--row">
            <div className="flex-table--row--cell">
              <b>{key.toString()}</b>
            </div>
            <div className="flex-table--row--cell">{(val || '').toString()}</div>
          </div>
        ))}
      </div>
      <h2 className="text-center">SSO Domains Claimed</h2>
      {ssoDomainsBody}
    </div>
  );
};

export default OrgInfoCard;
